import React from "react";
import styled from "styled-components";

const Navigation = styled.nav`
  border: 1px solid #000;
  background-color: #fff;
  display: flex;

  ul {
    font-family: lores-15, sans-serif;
    margin: 0;
    padding: 0;
    list-style: none;
    user-select: none;

    button {
      font-family: lores-15, sans-serif;
      font-size: 16px;
      text-align: left;
      background: none;
      border: none;
      margin: 0;
      padding: 4px 8px;
      @media (min-width: 768px) {
        padding: 4px 16px;
      }

      width: 100%;
      height: 100%;
    }

    > li {
      display: inline-block;
      padding: 0;

      @media (min-width: 768px) {
        padding: 0 16px;
      }

      position: relative;

      &:hover {
        background-color: #ccc;

        > ul {
          display: block;
          width: 180px;
          border: 1px solid #000;
          top: 25px;
          left: 0;

          li {
            padding: 0;
          }

          li:hover {
            background-color: #ccc;
          }
        }
      }

      > ul {
        z-index: 100;
        display: none;
        position: absolute;
        background-color: #fff;

        li {
          margin: 0;
          padding: 0;
          display: block;
        }
      }
    }
  }

  #lang {
    li {
      width: 60px;
      padding: 0 8px;
      position: relative;

      button {
        padding: 4px 8px;
        text-align: center;
      }
    }

    #ja {
      &::after {
        content: "|";
        position: absolute;
        top: 3px;
        right: 0;
      }
    }
  }
`;

const GlobalMenu = ({ switchLang, lang, manageWindow }) => {
  return (
    <Navigation>
      <ul>
        <li>
          <button
            onClick={() => {
              manageWindow("Top", true);
            }}
          >
            Top
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              manageWindow("About", true);
            }}
          >
            About
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              manageWindow("Research", true);
            }}
          >
            Research
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              manageWindow("Events", true);
            }}
          >
            Events
          </button>
        </li>
      </ul>
      <ul id="lang">
        <li id="ja">
          <button
            onClick={() => {
              switchLang(1);
            }}
            disabled={lang===1}
          >
            JA
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              switchLang(0);
            }}
            disabled={lang===0}
          >
            EN
          </button>
        </li>
      </ul>
    </Navigation>
  );
};

export default GlobalMenu;
